import { createIcon } from './create-icon'

export const HeartO = createIcon({
  displayName: 'HeartO',
  paths: [
    'M640 170.667c-48.256 0-92.245 16.64-128 43.605-35.755-26.965-79.744-43.605-128-43.605-117.803 0-213.333 95.488-213.333 213.333 0 48.256 16.64 92.245 43.605 128l265.643 304.64c8.491 9.685 20.267 14.549 32.085 14.549s23.595-4.864 32.085-14.549l265.643-304.64c26.965-35.755 43.605-79.744 43.605-128 0-117.845-95.531-213.333-213.333-213.333z'
  ]
})
